var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_views_table_view",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "table_FILL0_wght400_GRAD0_opsz48",
    d: "M6,31V6H31V31ZM8.083,13.639H28.917V8.083H8.083Zm7.639,7.639h5.556V15.722H15.722Zm0,7.639h5.556V23.361H15.722ZM8.083,21.278h5.556V15.722H8.083Zm15.278,0h5.556V15.722H23.361ZM8.083,28.917h5.556V23.361H8.083Zm15.278,0h5.556V23.361H23.361Z",
    transform: "translate(-6 -6)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon-table.b10972b02836d28a13482a5f7fa7443d.svg";
export { ForwardRef as ReactComponent };